<template>
  <div class="bgw" style="background:#fff">
    <order-tab ref="orderTab" />

    <div class="container" :style="{minHeight:height + 'px'}">
      <!-- <statements ref='statements'></statements> -->
      <!-- 预约订单 -->
      <booking-orders
        v-if="type === 1"
        @contect="contect"
        @concelShow="concelShowAction"
        @refund="refund"
        ref="booking"
      />
      
      <!-- 方案中订单 -->
      <div style="width:100%;padding-top:20px" v-if="type === 2">
        <div class="typeTab">
          <div v-for="(item,index) of typeList" :class="typeId==item.id?'typeBox typeBoxActive':'typeBox'" @click="typeId = item.id" :key="index">{{item.name}}</div>
        </div>
        <wait-confirm-orders
          v-if="typeId === 1"
          @selectService="selectService"
          @goodsConcel="goodsConcel"
          ref="wait"
          :ptype="type"/>

          <online-orders
          v-if="typeId === 2"
          @selectService="selectService"
          @goodsConcel="goodsConcel"
          ref="wait"
          :ptype="type"/>

          <ondoor-orders
          v-if="typeId === 3"
          @selectService="selectService"
          @goodsConcel="goodsConcel"
          ref="wait"
          :ptype="type"/>

      </div>
      

      
      <!-- 养护中订单 -->
      <curing-orders v-if="type === 3" @contect="contect" />
      <!-- 打包寄回订单 -->
      <wait-send-back-orders v-if="type === 4" @sendBack="sendBack" ref="package" :ptype="type" />
      <!-- 已完成订单 -->
      <div style="width:100%;padding-top:20px" v-if="type === 5">
        <div class="typeTab">
          <div v-for="(item,index) of typeList2" :class="typeId2==item.id?'typeBox typeBoxActive':'typeBox'" @click="typeId2 = item.id" :key="index">{{item.name}}</div>
        </div>
        <cpmplate-orders v-if="typeId2 === 1" @lookExpress="lookExpress" :ptype="type" />
        <com-online-orders v-if="typeId2 === 2" @lookExpress="lookExpress" :ptype="type"/>
        <com-ondoor-orders v-if="typeId2 === 3" @lookExpress="lookExpress" :ptype="type"/>
      </div>

    </div>
    <!-- 联系客服 -->
    <transition name="van-fade">
      <div class="markShdow" @click="showKefu = false" v-show="showKefu">
        <div>
          <img src="/images/base/weChart.png" align="middle" />
          <div class="qrcode-wrap">
            <img :src="dataUrl" alt />
          </div>
        </div>
      </div>
    </transition>

    <!-- 取消订单弹窗 -->
    <van-popup position="bottom" v-model="concelShow">
      <div class="containers f28">
        <div class="title">请选择取消订单的原因（必选）</div>
        <div class="close" @click="concelShow = false"></div>
        <ul>
          <li v-for="(item,index) in concelList" :key="index" @click="concelReason = item.key">
            <div>
              <radio @changeRadio="concelReason = item.key" :checked="concelReason == item.key" />
            </div>
            <span>{{item.value}}</span>
          </li>
        </ul>
        <button class="submit btn-black-round" :disabled="!concelReason" @click="concelSubmit">提交</button>
      </div>
    </van-popup>

    <!-- 退款进度弹窗 -->

    <van-popup position="bottom" v-model="refundShow">
      <div class="containers f28 content">
        <div class="title">退款进度</div>
        <div class="close" @click="refundShow = false"></div>
      </div>
    </van-popup>

    <!-- 选择修复选项弹窗 -->
    <van-popup position="bottom" v-model="serviceShow">
      <div class="containerService f28">
        <div v-for="(value,key) in serviceList" :key="key" v-if="value.length != 0">
          <div class="title">{{key == 'requiredGoodsCuringServiceList'?'必选服务项':'建议服务项'}}</div>
          <ul class="seviceUl">
            <li
              v-for="(item,index) in value"
              @click="changeActive(key,index)"
              :class="{actived:item.employStatus}"
            >
              <radio
                style="margin-right:20px"
                :checked="item.employStatus"
                v-show="key != "requiredGoodsCuringServiceList""
              />
              {{item.curingServiceName}}| ¥{{item.curingServicePrice}}x{{item.quantity}}
              <!-- 已购（{{item.paidQuantity}}） 还需（{{item.replenishQuantity}}） -->
            </li>
          </ul>
        </div>
        <div class="close" @click="serviceShow = false"></div>
        <div class="bottom">
          <button class="submit btn-black-round" @click="submitChoseService">确定</button>
          <span>已选 {{activedNum}} 种服务</span>
        </div>
      </div>
    </van-popup>

    <!-- 选择地址打包寄回 -->
    <van-popup position="bottom" v-model="adrShow">
      <div class="containerAdr f28">
        <div class="title">选择地址</div>
        <!-- <span @click="$router.push({ name: 'addressEdit'})">添加地址</span> -->
        <div class="close" @click="adrShow = false"></div>
        <div class="addr-container">
          <ul>
            <li v-for="(item,index) in adrList" :key="index" @click="adrClick(index)">
              <div class="li_div">
                <radio :checked="item.isDefault" />
              </div>
              <addr-com :model="item" :selected="item.trueDefault" />
            </li>
          </ul>
        </div>
        <button class="secondary" @click="$router.push({ name: 'addressEdit'})">添加地址</button>
        <button class="submit btn-black-round" :disabled="returnBtn" @click="submitAdr">确认寄回</button>
      </div>
    </van-popup>

    <!-- 查看物流信息 -->
    <van-popup position="bottom" v-model="expressShow">
      <div class="containerExpree f28">
        <div class="title">物流信息</div>
        <ul>
          <li>
            <span>快递公司：{{expressObj.expressPlatform}}</span>
          </li>
          <li>
            <span>快递单号：{{expressObj.expressCode}}</span>
            <button class="copy-btn" v-copy="expressObj.expressCode">复制</button>
          </li>
        </ul>
        <div class="close" @click="expressShow = false"></div>
      </div>
    </van-popup>

    <div class="boboPopup">
      <van-popup round v-model="mastKnow">
        <div class="my_popup">
          <div class="title">物品签收须知</div>
          <div class="scrollBox">
            <div class="scroll">
              你的快递已经准备寄出啦～
              <br />快递签收24小时内有问题都可以随时联系我！
              <br />
              <br />温馨提醒：
              <br />①签收后及时打开包装通风，再放入品牌防尘袋中收纳；
              <br />②避免包包放置于高温、潮湿环境，避免重物挤压。建议包内放置防潮珠以免包包里面发霉（南方的包粉更要注意防潮哦）；
              <br />③在包拯精心护理后，短期内无需再做二次保养（护理乳、清洁膏），会容易产生掉色哦；
              <br />④使用 『护理套装』请阅读使用说明，少量使用
              <br />
            </div>
          </div>
          <button
            class="primary mySendBack"
            @click="reallySubmitAdr"
            :disabled="second>0"
          >我已阅读&nbsp;{{second>0 ? second:''}}</button>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import bookingOrders from "./bookingOrders";
import waitConfirmOrders from "./waitConfirmOrders";
import onlineOrders from "./onlineOrders";
import ondoorOrders from "./ondoorOrders";
import waitSendBackOrders from "./waitSendBackOrders";
import curingOrders from "./curingOrders";
import cpmplateOrders from "./completeOrders";
import comOnlineOrders from "./comOnlineOrders";
import comOndoorOrders from "./comOndoorOrders";
import orderApi from "@/axios/order";
import myApi from "@/axios/my";
import { Toast } from "vant";
import { Dialog } from "vant";
import publicObj from "@/assets/js/public";
import QRCode from "qrcode";
import zhugeObj from "@/assets/js/track";
import $ from "jquery";
export default {
  name: "orderList",
  components: {
    bookingOrders,
    waitConfirmOrders,
    onlineOrders,
    ondoorOrders,
    waitSendBackOrders,
    curingOrders,
    cpmplateOrders,
    comOnlineOrders,
    comOndoorOrders
  },

  computed: {
    customerId() {
      return this.$store.state.customerId;
    },
    servicePhoneName() {
      return this.$store.state.servicePhoneName;
    },
    type() {
      let type = parseInt(this.$route.params.type);
      if (type == 2) {
        if (this.$refs.wait) {
          this.$refs.wait.parentsAction();
        }
      } else if (type == 4) {
        if (this.$refs.package) {
          this.$refs.package.parentsAction();
        }
      }

      return type;
    },
    activedNum() {
      let num = 0;
      Object.keys(this.serviceList).forEach(element => {
        this.serviceList[element].forEach(ele => {
          if (ele.employStatus) num++;
        });
      });
      return num;
    },
    returnBtn() {
      let tag = true;
      this.adrList.forEach(element => {
        if (element.isDefault) {
          tag = false;
        }
      });

      return tag;
    }
  },
  data() {
    return {
      second: 0,
      timer: null,
      mastKnow: false,
      expressShow: false,
      dataUrl: "",
      adrShow: false,
      adrList: [],
      serviceShow: false,
      serviceList: [],
      refundShow: false,
      concelReason: "",
      concelList: [],
      concelShow: false,
      showKefu: false,
      concelId: null,
      goodsConcelId: null,
      expressObj: {},
      goodsServiceId: "",
      sendBackArr: [],
      height: "",
      host: window.location.host,

      typeList: [
        { name: '养护服务', id: 1 },
        { name: '在线服务', id: 2 },
        { name: '上门服务', id: 3 }
      ],
      typeId: 1,
      typeList2: [
        { name: '养护服务', id: 1 },
        { name: '在线服务', id: 2 },
        { name: '上门服务', id: 3 }
      ],
      typeId2: 1,
    };
  },
  created() {
    this.getReasonList();
  },
  mounted() {
    QRCode.toDataURL(
      publicObj.byCustomerIdCreateQRcode(this.servicePhoneName)
    ).then(res => {
      this.dataUrl = res;
    });

    this.height = window.screen.height - this.$refs.orderTab.$el.offsetHeight;
  },
  methods: {
    lookExpress(item) {
      this.expressObj = item;
      this.expressShow = true;
    },
    sendBack(arr) {
      this.sendBackArr = arr;

      let params = {};
      params.goodsIdList = this.sendBackArr;
      orderApi.judgePackageDelivery(params).then(res => {
        if (!res) {
          this.getAdressList();
          this.adrShow = true;
        } else {
          Dialog.confirm({
            title: "提示",
            message: res,
            confirmButtonText: "再想想",
            cancelButtonText: "寄回"
          })
            .then(() => {
              // on confirm
            })
            .catch(() => {
              // on cancel
              if (this.adrList.length == 0) {
                this.adrShow = true;
                this.getAdressList();
              } else {
                this.$router.push({ name: "addressEdit" });
              }
            });
        }
      });
    },
    adrClick(index) {
      this.adrList.forEach((element, idx) => {
        if (index == idx) {
          element.isDefault = true;
        } else {
          element.isDefault = false;
        }
      });
    },
    getAdressList() {
      myApi.customerAddress({}).then(res => {
        res.forEach(element => {
          element.trueDefault = element.isDefault;
        });
        this.adrList = res;
      });
    },
    submitAdr() {
      let params = {
        // goodsIdList : this.sendBackArr
      };
      this.adrList.forEach(element => {
        if (element.isDefault) {
          params = element;
        }
      });
      if (!params.id) {
        Toast("请选择地址");
        return false;
      }
      this.mastKnow = true;
      this.adrShow = false;
      this.second = 3;
      this.timer = setInterval(() => {
        if (this.mastKnow) {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
          }
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },

    reallySubmitAdr() {
      let params = {
        // goodsIdList : this.sendBackArr
      };
      this.adrList.forEach(element => {
        if (element.isDefault) {
          params = element;
        }
      });
      params.customerAddressId = params.id;
      params.goodsIdList = this.sendBackArr;

      orderApi.packageDelivery(params).then(res => {
        zhugeObj.track({
          title: "待寄回—打包寄回",
          content: {
            地址: params.id,
            物品: this.sendBackArr
          }
        });
        Toast("打包成功");
        this.$refs.package.parentsAction();
        this.$refs.orderTab.getNum();
        let shareBody = {};
        this.mastKnow = false;
        // this.$router.replace({
        //   name: "orderList",
        //   params: {
        //     type: 5
        //   }
        // });
        window.location.href = 'http://support.baomaiduole.com/order/newShare?token=' + this.$store.state.token + '&custormerId=' + this.$store.state.customerId + '&servicePhone=' + this.$store.state.servicePhone
      });
    },

    changeActive(key, index) {
      if (key == "requiredGoodsCuringServiceList") {
        return;
      }

      if (this.serviceList[key][index].employStatus) {
        console.log(1);
        if (this.serviceList[key][index].requiredStatus) {
          Toast("此服务向必须选中");
          return;
        }

        if (this.serviceList["requiredGoodsCuringServiceList"].length == 0) {
          let employArr = this.serviceList[
            "adviseGoodsCuringServiceList"
          ].filter(item => item.employStatus);
          if (employArr.length == 1) {
            Toast("请至少选择一个服务项，如果取消请联系客服!");
            return;
          }
        }

        Dialog.confirm({
          title: "提示",
          message: "您确认要取消不做该服务项吗？",
          confirmButtonText: "再想想",
          cancelButtonText: "不做了"
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            // on cancel
            this.serviceList[key][index].employStatus = !this.serviceList[key][
              index
            ].employStatus;
          });
      } else {
        this.serviceList[key][index].employStatus = !this.serviceList[key][
          index
        ].employStatus;
      }
    },
    selectService(id) {
      // this.serviceShow = true;
      this.goodsServiceId = id;
      orderApi.goodsCuringService(id).then(res => {
        let obj = {
          requiredGoodsCuringServiceList: res.requiredGoodsCuringServiceList,
          adviseGoodsCuringServiceList: res.adviseGoodsCuringServiceList
        };
        this.serviceList = obj;
        this.serviceShow = true;
      });
    },
    submitChoseService() {
      let params = {
        goodsId: this.goodsServiceId
      };
      let Arr = [];
      Object.keys(this.serviceList).forEach(element => {
        this.serviceList[element].forEach(ele => {
          Arr.push({
            id: ele.id,
            employStatus: ele.employStatus
          });
        });
      });
      params.goodsCuringServiceEmployList = Arr;
      orderApi.setEmployService(params).then(res => {
        Toast("设置成功");
        this.serviceShow = false;
        this.$refs.wait.parentsAction();
        this.$refs.orderTab.getNum();
      });
    },
    refund(id) {
      this.refundShow = true;
    },

    goodsConcel(id) {
      this.goodsConcelId = id;
      this.concelShow = true;
    },
    concelShowAction(id) {
      this.concelId = id;
      this.concelShow = true;
    },
    getReasonList() {
      orderApi.getCancelReason({}).then(res => {
        this.concelList = res;
      });
    },
    contect() {
      this.showKefu = true;
    },
    concelSubmit() {
      if (this.type == 1) {
        let params = {
          id: this.concelId,
          cancelReasonId: this.concelReason
        };
        let cancelName = "";
        this.concelList.forEach((element, index) => {
          if (element.key == this.concelReason) {
            cancelName = element.value;
          }
        });
        orderApi.cancelBookingsOrder(params).then(res => {
          this.concelShow = false;
          Toast("取消成功");
          zhugeObj.track({
            title: "预约-点击取消预约",
            content: {
              取消原因: cancelName,
              预约单Id: this.concelId,
              结果: "成功"
            }
          });
          this.$refs.booking.parentsAction();
          this.$refs.orderTab.getNum();
          this.$refs.statements.getstatements();
        });
      } else {
        let params = {
          id: this.goodsConcelId,
          cancelReasonId: this.concelReason
        };
        orderApi.goodsCancel(params).then(res => {
          Toast("取消成功");
          this.concelShow = false;
          this.$refs.wait.parentsAction();
          this.$refs.orderTab.getNum();
        });
      }
    }
  }
};
</script>


<style scoped lang="scss">
.boboPopup {
  .van-popup {
    background: transparent;
  }
}
.my_popup {
  width: 420px;
  border-radius: 10px;
  background-color: #fff;
  padding: 50px 80px;
  .title {
    font-size: 34px;
    text-align: center;
    font-weight: bold;
  }
  .scrollBox {
    margin-top: 30px;
    width: 100%;
    height: 400px;
    font-size: 26px;
    line-height: 44px;
    overflow: auto;
    .scroll {
      width: 100%;
    }
  }
  .mySendBack {
    margin: 40px auto 0;
    display: block;
  }
}

.bgw {
  background: #fff !important;
}
.markShdow {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  z-index: 99;
}
.markShdow div {
  width: 100%;
  position: relative;
  margin-top: 200px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
}
.markShdow div > img {
  width: 100%;
}
.markShdow div .qrcode-wrap {
  position: absolute;
  bottom: 15px;
  width: 280px;
  height: 280px;
  background: red;
  left: 50%;
  margin-left: -140px;
}
.container {
  // position: absolute;
  margin-top: 102px;
  // top: 102px;
  // bottom: 98px;
  // left: 0;
  width: 100%;

  background: #fff;
  // overflow-y: scroll;
}

.containers {
  height: 740px;
  padding: 30px;
  position: relative;
  .title {
    line-height: 40px;
    margin-bottom: 50px;
  }
  ul li {
    width: 100%;
    height: 40px;

    margin-bottom: 60px;
    display: flex;
    align-items: center;
    span {
      margin-top: 2px;
    }
    & > div {
      margin-right: 20px;
    }
  }
  .submit {
    position: absolute;
    bottom: 30px;
    right: 30px;
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
}
.content {
  height: 300px;
}

.van-popup--bottom {
  width: 101%;
}
.containerService {
  min-height: 548px;
  padding: 30px;
  position: relative;
  padding-bottom: 100px;
  .title {
    line-height: 40px;
    margin-bottom: 50px;
    font-weight: 500;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
  }
  li {
    padding: 0 30px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 34px;
    margin-bottom: 50px;
    width: 100%;
    // background: rgba(236,236,236,1);
    // border: 1px solid rgba(236,236,236,1);
    &.actived {
      // border: 1px solid #7ADFDF;
      // background: rgba(121,207,207,0.1);
    }
  }
  .bottom {
    position: absolute;
    width: 690px;
    bottom: 30px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    .submit {
      margin-left: 20px;
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
}

.containerAdr {
  height: 860px;
  padding: 32px;
  position: relative;
  padding-bottom: 60px;
  padding-top: 0px;
  .title {
    line-height: 90px;
    border-bottom: 1px solid #eeeeee;
    font-size: 28px;
    font-weight: 500;
  }
  & > span {
    position: absolute;
    right: 30px;
    top: 80px;
    color: #7adfdf;
  }
  .addr-container {
    height: 700px;
    overflow-y: scroll;
    ul li {
      width: 100%;
      display: flex;
      padding-top: 32px;

      // align-items: center;
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
  .secondary {
    position: absolute;
    bottom: 27px;
    right: 270px;
  }

  .submit {
    position: absolute;
    bottom: 20px;
    right: 30px;
  }
}
.containerExpree {
  min-height: 380px;
  padding: 30px;
  position: relative;
  .title {
    line-height: 40px;
    margin-bottom: 50px;
  }
  li {
    line-height: 40px;
    margin-bottom: 30px;
    .copy-btn {
      margin-left: 20px;
    }
  }
  .bottom {
    position: absolute;
    width: 690px;
    bottom: 30px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    .submit {
      margin-left: 20px;
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
}


.typeTab{
  width: 690px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  align-content: flex-start;
  border: 1px solid #333;
  border-radius: 12px;
  overflow: hidden;
  .typeBox{
    flex-grow: 1;
    height: 100%;
    text-align: center;
    font-size: 32px;
    line-height: 58px;
    border-left: 1px solid #333;
    &:nth-child(1) {
      border: none;
    }
  }
  .typeBoxActive{
    background-color: #333;
    color: white;
  }
}
</style>
<style>
.van-list__finished-text {
  margin-bottom: 190px;
}
</style>

